/* FIND ERRORCODE LIST IN APP-README.txt */


import {API_DEBUG, MAX_API_TIMEOUT} from '../../../src/App/Constants';


export type HandleFetchError = {
   code: number
   error: Error
}

export const fetchTimeout = ()=>{
   return new Promise((_, reject) => {
      setTimeout(() => {
      reject(522);
      }, MAX_API_TIMEOUT*1000);
   });
};


export const handleFetchError = (err: number): HandleFetchError=>{
   let message = '';
   switch (err)
   {
   case 202:
      message = 'missing app-account capability';
      break;
   case 400: // bad request
      message = 'bad request';
      break;
   case 401:
      message = 'Not authorized';
      break;
   case 403:
      message = 'access forbidden';
      break;
   case 404:
      message = 'route not found';
      break;
   case 423:
      message = 'Lockout due to many failed login attempts. try again after 15 minutes.';
      break;
   case 429:
      message = 'Too many requests, please try again later.';
      break;
   case 500:
      message = 'JSON parse error';
      break;
   case 502:
      message = 'empty result';
      break;
   case 510:
      message = 'API not available';
      break;
   default:
      message ='access failed (%|STATUS|%)'.replace('%|STATUS|%',String(err));
   }

   throw({error:new Error(message), code:err});
};


export const handleResult = async (result: Response): Promise<Object>=>{

   if (API_DEBUG) console.log('ROOT:return json',result);

   if (!result)
   {
      return handleFetchError(502);
   }else if (!result.ok)
   {
      return handleFetchError(result.status);
   }else {
      try{
         return await result.json().then((json: Object)=>{
            return json;
         });
      }catch(_){
         return handleFetchError(500);
      }
   }
};
